var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 11.52,
    height: 11.52,
    rx: 5.76,
    fill: "#3394F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23678 8.925C5.96678 8.925 5.70678 8.89 5.45678 8.82C5.21011 8.74667 5.00511 8.645 4.84178 8.515L5.09178 7.955C5.43511 8.195 5.81844 8.315 6.24178 8.315C6.46844 8.315 6.64178 8.28 6.76178 8.21C6.88511 8.13667 6.94678 8.035 6.94678 7.905C6.94678 7.79167 6.89011 7.70334 6.77678 7.64C6.66678 7.57334 6.47178 7.51 6.19178 7.45C5.87844 7.38667 5.62844 7.31 5.44178 7.22C5.25844 7.12667 5.12344 7.015 5.03678 6.885C4.95344 6.75167 4.91178 6.58667 4.91178 6.39C4.91178 6.17667 4.97011 5.985 5.08678 5.815C5.20678 5.645 5.37344 5.51334 5.58678 5.42C5.80011 5.32334 6.04678 5.275 6.32678 5.275C6.58011 5.275 6.82344 5.31167 7.05678 5.385C7.29011 5.45834 7.47678 5.55834 7.61678 5.685L7.36678 6.245C7.05344 6.005 6.70844 5.885 6.33178 5.885C6.13178 5.885 5.97178 5.925 5.85178 6.005C5.73178 6.085 5.67178 6.19334 5.67178 6.33C5.67178 6.41 5.69344 6.47667 5.73678 6.53C5.78344 6.58334 5.86011 6.63167 5.96678 6.675C6.07344 6.715 6.22511 6.755 6.42178 6.795C6.87844 6.895 7.20678 7.025 7.40678 7.185C7.61011 7.345 7.71178 7.56334 7.71178 7.84C7.71178 8.17334 7.58178 8.43834 7.32178 8.635C7.06178 8.82834 6.70011 8.925 6.23678 8.925Z",
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 1,
    width: 11.52,
    height: 11.52,
    rx: 5.76,
    fill: "#3394F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9604 4.32L19.6954 7.88H19.0704L18.2404 5.525L17.4054 7.88H16.7804L15.5154 4.32H16.3104L17.1304 6.78L17.9904 4.32H18.5354L19.3754 6.815L20.2154 4.32H20.9604Z",
    fill: "#FAFAFA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12,
    width: 11.52,
    height: 11.52,
    rx: 5.76,
    fill: "#3394F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76254 19.925C6.40921 19.925 6.10087 19.8517 5.83754 19.705C5.57754 19.555 5.37587 19.3417 5.23254 19.065C5.09254 18.7884 5.02254 18.465 5.02254 18.095C5.02254 17.725 5.09254 17.4034 5.23254 17.13C5.37587 16.8567 5.57754 16.6467 5.83754 16.5C6.10087 16.35 6.40921 16.275 6.76254 16.275C7.11587 16.275 7.42254 16.35 7.68254 16.5C7.94254 16.6467 8.14254 16.8567 8.28254 17.13C8.42254 17.4034 8.49254 17.725 8.49254 18.095C8.49254 18.465 8.42254 18.7884 8.28254 19.065C8.14254 19.3417 7.94254 19.555 7.68254 19.705C7.42254 19.8517 7.11587 19.925 6.76254 19.925ZM6.76254 19.315C7.06254 19.315 7.29587 19.21 7.46254 19C7.63254 18.79 7.71754 18.4884 7.71754 18.095C7.71754 17.7017 7.63254 17.4017 7.46254 17.195C7.29587 16.9884 7.06254 16.885 6.76254 16.885C6.46254 16.885 6.22754 16.9884 6.05754 17.195C5.89087 17.4017 5.80754 17.7017 5.80754 18.095C5.80754 18.4917 5.89087 18.795 6.05754 19.005C6.22754 19.2117 6.46254 19.315 6.76254 19.315Z",
    fill: "#FAFAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 11.5199,
    height: 11.52,
    rx: 5.75996,
    fill: "#3394F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.365 16.955H16.25V16.32H19.27V16.955H18.155V19.88H17.365V16.955Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwot);
export default __webpack_public_path__ + "static/media/swot.271728b5b41a501c1058bff95c4488e9.svg";
export { ForwardRef as ReactComponent };